import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LangService, LoaderService} from '@satoris/ngx-satoris';
import {ApiService} from '../../shared/services/api.service';
import {getStoredItem} from '../../shared/utils/storage';

// The target of the confirmation link in the email or SMS (UserController.confirmationLink), opened in the browser or, through App Links
// and Universal Links, in the app.
@Component({
  selector: 'app-confirm-account',
  template: ''
})
export class ConfirmAccountComponent implements OnInit {

  constructor(private route: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private loader: LoaderService,
    private lang: LangService) {}

  private latestLink = 0;

  ngOnInit(): void {
    // Signed in to another account, home passes the app on to user and the guards there close any dialog, so the result is shown here first.
    const signedIn = Boolean(getStoredItem('jwt')?.jwt);
    const show = (type: 'valid' | 'error', key: string) => this.loader.loading(true, {type, message: this.lang.transform(key)});
    // A link opened while another is pending or its dialog is shown reuses this component; only the newest link may navigate or show a result.
    this.route.paramMap.subscribe(params => {
      const link = ++this.latestLink;
      const isNewest = () => link === this.latestLink;
      const toUser = () => isNewest() && this.router.navigate(['/user']);
      this.loader.loading(true);
      this.api.confirm(+params.get('user_id'), params.get('salt')).then(() => {
        if(!isNewest()) return;
        signedIn ? show('valid', 'just.activatedAccount').then(toUser) : this.router.navigate(['/home'], {queryParams: {first: true}});
      }, () => {
        if(!isNewest()) return;
        signedIn ? show('error', 'accountValid.confirmError').then(toUser) : this.router.navigate(['/home']).then(() => show('error', 'accountValid.confirmError'));
      });
    });
  }
}
